import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  // Lazy getter to avoid circular dependency
  private get toastr(): ToastrService {
    return this.injector.get(ToastrService);
  }

  handleError(error: any): void {
    // Log to console for debugging
    console.error('Global error caught:', error);

    try {
      if (error instanceof HttpErrorResponse) {
        // HTTP error from backend
        this.handleHttpError(error);
      } else if (error instanceof Error) {
        // Client-side error
        this.handleClientError(error);
      } else {
        // Unknown error
        this.toastr.error('Ha ocurrido un error inesperado', 'Error');
      }
    } catch (toastrError) {
      // If toastr fails, just log to console
      console.error('Error showing toast notification:', toastrError);
    }
  }

  private handleHttpError(error: HttpErrorResponse): void {
    if (error.status === 0) {
      // Network error or CORS issue
      this.toastr.error(
        'No se pudo conectar al servidor. Por favor verifica tu conexión.',
        'Error de Conexión'
      );
    } else if (error.status >= 500) {
      // Server error
      const message = error.error?.message || 'Error del servidor. Por favor intenta más tarde.';
      this.toastr.error(message, 'Error del Servidor');
    } else if (error.status >= 400) {
      // Client error (400-499)
      const message = error.error?.message || 'Error en la solicitud.';
      this.toastr.error(message, 'Error');
    }
  }

  private handleClientError(error: Error): void {
    // Client-side JavaScript error
    this.toastr.error(
      error.message || 'Ha ocurrido un error inesperado',
      'Error'
    );
  }
}
